/**
 * RulebookLinkCard — small nav card on the Diagnostics console linking
 * to the Rulebook. Diagnostics is the owner's cockpit; the Rulebook
 * should be one click from it.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookMarked, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function RulebookLinkCard() {
  const navigate = useNavigate();
  return (
    <Card
      className="mb-3 border-amber-200 bg-amber-50/40 hover:bg-amber-50 transition-colors cursor-pointer"
      onClick={() => navigate('/admin/rulebook')}
      data-testid="diagnostics-rulebook-card"
    >
      <CardContent className="py-3 px-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <BookMarked className="w-5 h-5 text-amber-700" />
          <div>
            <div className="text-sm font-semibold text-stone-900">The Rulebook</div>
            <div className="text-xs text-stone-600">
              Living reference: features, data, rules, code, and known discrepancies.
            </div>
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-stone-500" />
      </CardContent>
    </Card>
  );
}
